function pushViewCartEvent() {
  fetch('/cart.js')
    .then((response) => response.json())
    .then((cart) => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_cart',
        ecommerce: {
          currency: cart.currency,
          value: cart.total_price / 100,
          items: cart.items.map((item, index) => ({
            item_id: `${item.product_id}`,
            item_variant_id: `${item.variant_id}`,
            item_name: item.product_title,
            item_variant: item.variant_title,
            price: item.price / 100,
            quantity: item.quantity,
            index
          }))
        }
      });
    })
    .catch((e) => {
      console.error(e);
    });
}

class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
    pushViewCartEvent();
  }

  renderContents(parsedState) {
    if (!parsedState?.sections) {
      this.open();
      return;
    }

    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element) return;
      const html = parsedState.sections[section.section] ?? parsedState.sections[section.id];
      if (!html) return;
      const inner = this.getSectionInnerHTML(html, section.selector);
      if (inner != null) element.innerHTML = inner;
    });

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    if (!html) return '';
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const el = doc.querySelector(selector);
    return el ? el.innerHTML : '';
  }
}

customElements.define('mini-cart', MiniCart);
